/* @flow */

import * as React from 'react';

import './map.css';

type Props = {coordinates: ?{latitude: string, longitude: string}, isBlurred?: boolean};

const ZOOM = 4;

export function Map(props: Props) {
    const mapUrl = props.coordinates
        ? `https://api.mapbox.com/styles/v1/${MapboxConfig.newMapId}/static/${props.coordinates.longitude},${props.coordinates.latitude},${ZOOM}/400x150?access_token=${MapboxConfig.apiKey}&attribution=false&logo=false`
        : undefined;

    return (
        <div styleName={props.isBlurred ? 'map--blurred' : 'map'}>
            <div styleName='marker-icon'></div>
            {mapUrl ? <img src={mapUrl} alt='Company location map' /> : undefined}
        </div>
    );
}
